import { GET_CORPORATE_CLIENT_FAILURE, GET_CORPORATE_CLIENT_REQUEST, GET_CORPORATE_CLIENT_SUCCESS, GET_CORPORATE_CLIENT_CLEAR, GetCorporateClientActionTypes, GetCorporateClientState } from './types';

const defaultState: GetCorporateClientState = {
  isLoading: false,
  errorMessage: "",
};

export default function getCorporateClient(state = defaultState, action: GetCorporateClientActionTypes): GetCorporateClientState {
  switch (action.type) {
    case GET_CORPORATE_CLIENT_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_CORPORATE_CLIENT_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_CORPORATE_CLIENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    case GET_CORPORATE_CLIENT_CLEAR:
      return {
        ...state,
        isLoading: false,
        errorMessage: "",
        contents: undefined
      };
    default:
      return state;
  }
};
